export default {
	title: 'Lista de Dispositivos',
	actions: {
		add: 'Añadir',
		edit: 'Editar',
		delete: 'Eliminar',
		batchDelete: 'Eliminación por Lote',
		save: 'Guardar',
		cancel: 'Cancelar',
		confirm: 'Confirmar'
	},
	messages: {
		deleteSuccess: 'Eliminación exitosa',
		actionSuccess: 'Operación exitosa',
		noDeviceSelected: 'Por favor, seleccione los dispositivos a configurar',
		noWaveTypeSelected: 'Por favor, seleccione un tipo de forma de onda',
		dataCollectSuccess: 'Recopilación de datos emitida con éxito',
		configSuccess: 'Configuración exitosa',
		settingSuccess: 'Configuración exitosa'
	},
	labels: {
		deviceList: 'Lista de Dispositivos',
		startStopRecord: 'Registro de Inicio-Parada',
		dilutionStrategy: 'Estrategia de Dilución',
		dataCollectIssuance: 'Emisión de Recopilación de Datos',
		markConfig: 'Configuración de Marca',
		diagnose: 'Diagnosticar',
		deviceSensorConfig: 'Configuración de Sensor del Dispositivo',
		alarmTag: 'Etiqueta de Alarma',
		runAlarmAlgorithm: 'Ejecutar Algoritmo de Alarma',
		notRunAlarmAlgorithm: 'No Ejecutar Algoritmo de Alarma'
	},
	buttons: {
		dilutionStrategy: 'Estrategia de Dilución',
		dataCollectIssuance: 'Emisión de Recopilación de Datos',
		add: 'Añadir',
		markConfig: 'Configuración de Marca',
		batchDelete: 'Eliminación por Lote',
		deviceMoveOrg: 'Registro de Movimiento de Dispositivo',
		diagnose: 'Diagnosticar',
		deviceSensorConfig: 'Configuración de Sensor del Dispositivo',
		startStopRecord: 'Registro de Inicio-Parada',
		edit: 'Editar',
		delete: 'Eliminar',
		cancel: 'Cancelar',
		confirm: 'Confirmar'
	},
	table: {
		deviceName: 'Nombre del Dispositivo',
		deviceNumber: 'Número del Dispositivo',
		projectNumber: 'Número de Proyecto',
		org: 'Organización',
		type: 'Tipo',
		status: 'Estado',
		warnLevel: 'Nivel de Advertencia',
		runAlarmAlgorithm: 'Ejecutar Algoritmo de Alarma',
		modelImage: 'Imagen del Modelo',
		deviceImage: 'Imagen del Dispositivo',
		action: 'Acción',
		oldOrgName: 'Organización Original',
		newOrgName: 'Nueva Organización',
		moveDate: 'Fecha de Movimiento',
		operatorName: 'Operador'
	},
	form: {
		placeholder: {
			deviceNumber: 'Número del Dispositivo',
			deviceName: 'Nombre del Dispositivo',
			org: 'Nombre de la Organización',
			projectNumber: 'Número de Proyecto',
			type: 'Nombre del Tipo',
			status: 'Estado'
		},
		add: 'Añadir',
		update: 'Editar',
		cancel: 'Cancelar',
		confirm: 'Confirmar'
	},
	dialog: {
		dilutionStrategy: 'Estrategia de Dilución',
		dataCollectIssuance: 'Emisión de Recopilación de Datos',
		shortWaveform: 'Forma de Onda Corta',
		longWaveform: 'Forma de Onda Larga',
		quarter: 'Trimestre',
		halfYear: 'Semestre',
		year: 'Año',
		markConfig: 'Configuración de Marca',
		deviceMoveOrg: 'Registro de Movimiento de Dispositivo',
		alarmTagRequired: 'La etiqueta de alarma es obligatoria',
		closeLongWaveform: 'Desactivar Forma de Onda Larga',
		openLongWaveform: 'Activar Forma de Onda Larga',
		closeLongWaveformConfirm: 'Esta operación afectará a la configuración de almacenamiento de "forma de onda larga" de TODOS los dispositivos (las formas de onda largas ya no se guardarán). Las formas de onda de alta/baja frecuencia no se ven afectadas. ¿Continuar?',
		openLongWaveformConfirm: 'Esta operación afectará a la configuración de almacenamiento de "forma de onda larga" de TODOS los dispositivos (se restablecerá el guardado de formas de onda largas). Las formas de onda de alta/baja frecuencia no se ven afectadas. ¿Continuar?',
		setCjpzSuccess: 'Configuración exitosa'
	},
	config: {
		gridLayout: 'Diseño de Cuadrícula',
		deviceName: 'Nombre del Dispositivo',
		deviceNumber: 'Número del Dispositivo',
		project: 'Proyecto',
		status: 'Estado',
		deviceType: 'Tipo de Dispositivo',
		diagnosticToolType: 'Tipo de Herramienta de Diagnóstico',
		org: 'Organización',
		deviceImage: 'Imagen del Dispositivo',
		deviceModelImage: 'Imagen del Modelo del Dispositivo',
		sort: 'Ordenar',
		pointName: 'Nombre del Punto',
		startStopSpeed: 'Valor de Velocidad de Inicio-Parada',
		startStopAcc: 'Valor de Aceleración de Inicio-Parada',
		abnormalTemp: 'Valor de Temperatura Anormal',
		abnormalSpeed: 'Valor de Velocidad Anormal',
		accThreshold: 'Umbral de Aceleración',
		speedThreshold: 'Umbral de Velocidad',
		tempThreshold: 'Umbral de Temperatura',
		label1: 'Etiqueta 1',
		nameRequired: 'El campo obligatorio no puede estar vacío',
		orgPlaceholder: 'Organización (Diagnóstico)'
	},
	index: {
		deviceList: 'Lista de Dispositivos',
		startStopRecord: 'Registro de Inicio-Parada'
	}
}
